export class NewUser {
    firstName: string;
    lastName: string;
    phoneNumber: string;
    password: string;
    otp: string;
    otpId: string;
    referredCode?: string;
}
export class UserDetails {
    firstName: string;
    lastName: string;
    phoneNumber: string;
    password: string;

}
export class SessionInfo {
    Authorization: string;
    userId: string;
}

export class personalInfo {
    UserId: string;
    firstName: string;
    lastName: string;
    phoneNumber: string;
}

export class upersonalInfo {
        'userId': string;
        "firstName": string;
        "lastName": string;
        "phoneNumber": string;
        "email": string;
        "referralCode": null;
        "referredCode": null;
    }
export class UserInfo {
    name: string;
    address: string;
    city: string;
    state: string;
    pinCode: string;
    locality: string;
    contactNumber: string;
}
export class Login{
    phoneNumber: string;
    password: string;
}
export class signUp{
    phoneNumber: string;
    otp: string;
    otpId: string;
    password: string;
    firstName: string;
    lastName: string;
    referredCode:string;
}

export class otpVerify{
    otpId: string;
    otp: number;
    phoneNumber: number;
}

export class referrals{
    onelapReferredCoins: 100;
    onelapReferringCoins: 100;
    orderId: null;
    redeemableDate: null;
    referralId: "eEu2alaS3j";
    referredUserId: "twmba6k77eg3Vp1A79kfZHRphzm9X1";
    referredUsername: "abhishek mishra";
    referringUserId: "yCPqfOE4XbGkopMqheSXTZK4k5U6fO";
    processed ?: boolean;
    referringUsername ?: "onelap user"}
    
export class forgetPassword{
    "firstName": string;
    "lastName": string;
    "password": string;
    "otpId": string;
    "otp": string;
    "phoneNumber": string;
}

export class Email{
    "title": String;
	"name": String;
	"email": String;
	"contactNumber": String;
	"description": String;
}